var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"login-container"},[_c('v-container',{staticClass:"login-wrapper"},[_c('v-row',{attrs:{"justify":"space-around"}},[_c('Stars'),_c('BackgroundPlanets',{attrs:{"max-planets-number":3}}),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }